import { Component, Input, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Script } from 'src/app/interfaces/script';
import { ScriptStatus } from 'src/app/interfaces/scriptStatus';
import { UtilService } from 'src/app/util/util.service';
import { ApplicationService } from '../application.service';
import { HistoricScriptModalComponent } from '../run-script/historic-script-modal/historic-script-modal.component';
import {
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
  MatExpansionPanelDescription
} from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { IconModule, LoaderModule } from '@michelin/theme';

@Component({
  selector: 'mic-app-run-script-element',
  templateUrl: './run-script-element.component.html',
  styleUrls: ['./run-script-element.component.scss'],
  imports: [
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatExpansionPanelDescription,
    MatIcon,
    MatTooltip,
    IconModule,
    LoaderModule
  ]
})
export class RunScriptElementComponent implements OnInit {
  private readonly applicationService = inject(ApplicationService);
  readonly utilService = inject(UtilService);
  dialog = inject(MatDialog);

  panelOpenState = false;
  @Input() script: any;
  scriptStatus: ScriptStatus;

  ngOnInit(): void {
    this.applicationService.getTheLastScriptStatus(this.script.id).subscribe((response) => {
      this.scriptStatus = response;
    });
  }
  onRunScript(script: Script) {
    this.applicationService.runScript(script).subscribe((response) => {
      // I will get the id of the status
      this.scriptStatus = response;
    });
    const intervalId = setInterval(() => {
      if (this.scriptStatus.status === 'OK') {
        clearInterval(intervalId);
      }
      this.applicationService.getScriptStatus(this.scriptStatus.id).subscribe((response) => {
        this.scriptStatus = response;
      });
    }, 1000);
  }

  onHistoric() {
    this.dialog.open(HistoricScriptModalComponent, {
      width: '800px',
      data: this.script.id
    });
  }
}
